import React  from 'react'
import styled from 'styled-components'
import { useSelector, useDispatch } from 'react-redux'
import { LAYER_POPUP } from 'estimate_list/reducers/initial'
// import EstimatePrint from "../layer/EstimatePrint";

const Share = () => {
    const { isLogin } = useSelector(state => state.user)
    const { domain } = useSelector(state => state.initial)

    const dispatch = useDispatch()

    const closeLayerPopup = () => {
        //로그인 확인 하는 이슈는 백에서 auth_token를 재생성할 때  HttpOnly를 true로 받고 있어서 생긴 이슈일 가능성으로 추측
        if(domain !== 'shopping'){
            if (!isLogin) {
                window.location.href = process.env.REACT_APP_SSO_URL
            }else{
                dispatchAction()
            }
        }else{
            dispatchAction()
        }
    }

    const dispatchAction=()=>{
        dispatch({
            type: LAYER_POPUP,
            data: 'share'
        })
    }

    return (
        <Style>
            <div title={domain !== 'shopping'?'견적 공유하기':'공유하기'}>
                <button className="button" onClick={closeLayerPopup}>
                    <i className="icon-share2" />
                </button>
            </div>
            {/*<EstimatePrint estimateIdx={176923} minishopIdx={9081} /> 미니샵테스트*/}
            {/*<EstimatePrint estimateIdx={176923}/> pc테스트 */}
        </Style>
    )
}

const Style = styled.div`
    margin: 0 0 5px;

    .button {
        display: flex;
        align-items: center;
        border: 1px solid #999;
        padding: 0 0 0 5px;
        width: 36px;
        height: 36px;
        border-radius: 18px;
        color: #999;
        cursor: pointer;

        &:hover {
            color: #418ded;
            border-color: #418ded;
        }

        i {
            font-size: 23px
        }
    }
`

export default Share



// WEBPACK FOOTER //
// ./src/estimate_list/components/share/index.js